<template>
  <div class="yk-stu-manager-new-wrapper clearfix" style="width:800px;">
    <el-form label-width="80px">
      <el-form-item label="协会">
        <el-input v-model="Name" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="logo：">
        <imageUpload :url="urlAliyunOSS" :files.sync="Logo" format="image"></imageUpload>
      </el-form-item>
      <el-form-item label="简介：">
        <Editor v-model="Introduce" placeholder="请输入内容"></Editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updateAssociation">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UploadFile from "components/UploadFile.vue";
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      Name: "",
      Logo: "",
      Introduce: "",
      url: "/api/design/osssign/getsign",
      files: [],
      fileList: [],
      urlAliyunOSS: "/api/design/osssign/getsign",
      MedalIconUrl: "",
      AvatorUrl: ""
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  components: {
    UploadFile,
    imageUpload
  },
  created() {
    this.getInfo();
  },
  watch: {
    AvatorUrl: function(val) {
      console.log(val);
    }
  },
  methods: {
    getInfo() {
      var that = this;
      this.$http.post("/api/XOrg/AOrgInfo/getInfo", {}).then(function(rst) {
        if (rst.code === 1 && rst.associationInfo) {
          that.Name = rst.associationInfo.Name;
          that.Logo = rst.associationInfo.Logo;
          that.Introduce = rst.associationInfo.Introduce;
        } else {
          that.$message.warning(rst.msg || "");
        }
      });
    },
    updateAssociation() {
      var that = this;
      this.$http
        .post("/api/XOrg/AOrgInfo/updateAssociation", {
          logoUrl: that.Logo,
          Introduce: that.Introduce
        })
        .then(function(rst) {
          if (rst.code === 1) {
            that.$message.success(rst.msg);
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>